@if (anchor) {
  <a [id]="anchor"></a>
}

@if (attributes.headline) {
  <h2 kb-heading type="divider" [appEditorId]="editorIds?.headline">{{attributes.headline}}</h2>
}

<app-visual-figure [section]="attributes.medium" [rootColumns]="attributes.numColumns"/>

@if (createSectionButton) {
  <app-fs-button [value]="createSectionButton"></app-fs-button>
}
